module.exports = __webpack_public_path__ + "static/media/LK.0cbb8160.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/LK.svg
// module id = 2196
// module chunks = 7